const {stripPathVersions } = require('./version');
const { getOperators, QueryBuilderAttributeTypes } = require('./operators');
const { attributePathToString } = require('./helper');
const { countries } = require('./country');
const cloneDeep = require('lodash/cloneDeep');

const resources = {
    countryName: 'Country',
    identitydocuments: 'Identity Documents',
    subRegion: 'Sub region',
    region: 'Region'
   
}
/**
 * The list of attribute paths to consolidate into a single attribute.
 */
const attributePathsToConsolidate = ([
    [countries.map((c) => `address.addressDetail.place.country.${c}.code`), { label: (resources.countryName), lastPathValue: 'country', type: QueryBuilderAttributeTypes.Enum}],
    [countries.map((c) => `identityDocuments.country.${c}.code`), { label: (resources.identitydocuments), lastPathValue: 'country', type: QueryBuilderAttributeTypes.Enum}],
    [countries.map((c) => `address.addressDetail.place.country.${c}.subRegion.code`), { label: (resources.subRegion), lastPathValue: 'subRegion', type: QueryBuilderAttributeTypes.String}],
    [countries.map((c) => `address.addressDetail.place.country.${c}.region.code`), { label: (resources.region), lastPathValue: 'region', type: QueryBuilderAttributeTypes.Enum}],
]);

/**
 * For the given attributes, check if attribute's path is one that needs consolidation. If so,
 * perform consolidate by creating a container attribute having a populated consolidatedAttributes
 * array.
 * @param attributes The attributes to consolidate.
 */
const consolidateAttributes = (attributes = []) => {
    attributePathsToConsolidate.forEach((attributePathToConsolidate) => {
        const paths = attributePathToConsolidate[0];
        const label = attributePathToConsolidate[1].label;
        const lastPathValue = attributePathToConsolidate[1].lastPathValue;
        const type = attributePathToConsolidate[1].type;
        const consolidatedAttribute = {
            consolidatedAttributes: [],
            enum: [],
            label,
            operators: getOperators(type),
            path: [],
            type: type,
        };
        for (let i = attributes.length - 1; i >= 0; i--) {
            const attribute = attributes[i];
            const attributePath = stripPathVersions(attributePathToString(attribute));
            paths.forEach((path) => {
                if (attributePath.endsWith(path)) {
                    // set consolidate path to be same path excluding matched part
                    if (!consolidatedAttribute.path.length) {
                        const lastPathItem = [...attribute.path].reverse().find((p) => p.value === lastPathValue);
                        const indexOfPathItemMatch = attribute.path.indexOf(lastPathItem);
                        if (indexOfPathItemMatch >= 0) {
                            consolidatedAttribute.path = [...attribute.path].slice(0, indexOfPathItemMatch + 1);
                        }
                        attributes.push(consolidatedAttribute);
                    }
                    consolidatedAttribute.consolidatedAttributes.push(attribute);

                    // remove the parent from attributes as it's no longer needed
                    attributes.splice(attributes.indexOf(attribute), 1);
                }
            });
        }
    });
    return attributes;
};

/**
 * For the given rules, consolidate the attributes that need to be consolidated but are not since
 * we save attributes to the database an uncosonlidated.
 */
 const consolidateRuleAttributes = (where = [], attributes = []) => {
    if (!where || !where.length) {
        return;
    }

    // consolidate attributes
    const consolidatedAttributes = attributes.filter((a) => isConsolidatedAttribute(a));
    consolidatedAttributes.forEach((ca) => {
        where.forEach((rule) => {
           const attribute = rule.attribute;
           if (!attribute || isConsolidatedAttribute(attribute)) {
               return;
           }
           const attributePath = attributePathToString(attribute);
           let consolidatedAttribute = null;
           for (const nestedCa of ca.consolidatedAttributes) {
               if (attributePathToString(nestedCa) === attributePath) {
                   consolidatedAttribute = ca;
                   break;
               }
           }

           if (consolidatedAttribute) {
               Object.assign(rule.attribute, consolidatedAttribute, { value: null });
           }
       });
   });
};

 const unconsolidateAttributes = (where = []) => {
    const newWhere = cloneDeep(where);

    for (let i = newWhere.length - 1; i >= 0; i--) {
        const rule = newWhere[i];

        if (!rule.attribute || !rule.value) {
            continue;
        }

        const attribute = rule.attribute;

        if (isConsolidatedAttribute(attribute)) {
            const nestedAttribute = attribute.consolidatedAttributes.find((a) =>
                a.enum.findIndex((e) => e.value === rule.value) >= 0);

            if (nestedAttribute) {
                attribute.consolidatedAttributes = null;
                attribute.path = nestedAttribute.path;
                attribute.value = nestedAttribute.value;
                attribute.label = nestedAttribute.label;
            } else {
                // remove this rule b/c it will cause the query to fail; shouldn't happen
                // since query builder requires attribute to exist
                newWhere.splice(i, 1);
            }
        }
    }

    return newWhere;
};

 const isConsolidatedAttribute = (attribute) => {
    return attribute && attribute.consolidatedAttributes && attribute.consolidatedAttributes.length > 0;
};

module.exports = {
    attributePathsToConsolidate,
    resources,
    consolidateAttributes,
    consolidateRuleAttributes,
    unconsolidateAttributes,
    isConsolidatedAttribute,
};